import { ArticleImage, loadLargeImage } from '../articleImage';
import {
  accordionInit,
  correctArticleHeight,
  contentListItemColor,
  fixFurtherContentHeadlineMargin,
  initModalRevealsForArticle,
  initTwoClickIframes
} from '../../articleHelper';
import ArticlePresenter from '../../articlePresenter';
import FormRenderer from '../forms/formRenderer';
import WidgetRenderer from '../widgets/widgetRenderer';
import React from 'react';
import $ from 'jquery';

class DefaultArticle extends React.Component {
  constructor() {
    super();
    this.state = {
      article: ArticlePresenter.nullArticle(),
      widgets: []
    };
  }

  componentDidMount() {
    this.ajaxArticle();
  }

  componentDidUpdate() {
    const { articleId } = this.props;

    fixFurtherContentHeadlineMargin();
    correctArticleHeight(articleId);
  }

  ajaxArticle() {
    const methods = [
      'selected_layout',
      'title',
      'content',
      'background_color',
      'background_option_for_content',
      'context_info',
      'image_links_mobil_oben_content',
      'image_alt_links_mobil_oben',
      'image_links_mobil_unten_content',
      'image_alt_links_mobil_unten',
      'image_focus_hintergrund_mini',
      'image_focus_hintergrund_teaser',
      'image_focus_hintergrund_background',
      'widget_ids'
    ].join();

    $.ajax({
      url: `/api/v3/articles/${
        this.props.articleId
      }.json?methods=${methods}&${window.location.search.substring(1)}`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          this.setState({ article: ArticlePresenter.getArticle(data) }, () => {
            loadLargeImage(this);
            contentListItemColor();
            WidgetRenderer.widgetsForObject(this.state.article, (widgets) => {
              this.setState({ widgets }, () => {
                correctArticleHeight(this.props.articleId);
                initModalRevealsForArticle(this.props.articleId);
                accordionInit();
                initTwoClickIframes();
              });
            });
          });
        }
      },
      error: (xhr, status, err) => console.error(this.props.articleId, status, err.toString())
    });
  }

  render() {
    const { article, widgets } = this.state;
    const layoutClass = '';

    return (
      <div
        className="background"
        style={Object.assign({}, article.imageBackground, {
          backgroundColor: article.backgroundColor
        })}
      >
        <div className="container">
          <div className="row">
            <article className={`content ${article.backgroundOptionForContent}`}>
              <div className={`row ${layoutClass}`}>
                {article.title && <h1 className="no-margin">{article.title}</h1>}
                <MainContent article={article} widgets={widgets} />
              </div>
            </article>
          </div>
        </div>
      </div>
    );
  }
}

DefaultArticle.propTypes = {
  articleId: React.PropTypes.number
};

function MainContent({ article, widgets }) {
  return (
    <div className="main-content">
      <ArticleImage imageUrl={article.imageLeftTopUrl} imageAlt={article.imageLeftTopAlt} />
      <div className="hidden-mobile">
        <ArticleImage imageUrl={article.imageLeftBottomUrl} imageAlt={article.imageLeftBottomAlt} />
      </div>
      {WidgetRenderer.renderWidgets(widgets, 'before-main-content')}
      <div dangerouslySetInnerHTML={{ __html: article.mainContent }} />
      {WidgetRenderer.renderWidgets(widgets, 'main-content-before-form')}
      {FormRenderer.displayFor(article, 'main_content')}
      <div dangerouslySetInnerHTML={{ __html: article.furtherContent }} />
      <div className="hidden-desktop">
        <ArticleImage imageUrl={article.imageLeftBottomUrl} imageAlt={article.imageLeftBottomAlt} />
      </div>
    </div>
  );
}

MainContent.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array
};

export default DefaultArticle;



// WEBPACK FOOTER //
// ./components/articles/externalArticle.js